export default {
      id: "arrow-special-rightdown-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-special-rightdown",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-special-rightdown.svg
// module id = 130
// module chunks = 241 242 243